/**
 * AUURAH: lift the Shopify Inbox chat bubble above the pinned sticky add-to-cart bar.
 * The Inbox widget renders in an open shadow DOM; its internal styles ignore inherited
 * CSS variables, so we transform the activator directly while the bar is stuck.
 * The lift is computed from the live bar height so it adapts to desktop and mobile.
 */
(function () {
  var GAP = 8; // breathing room between bubble and bar top

  function getBar() {
    return document.querySelector(".sticky-add-to-cart__bar");
  }

  function getActivator(chatEl) {
    try {
      var sr = chatEl.shadowRoot;
      if (!sr) return null;
      return sr.querySelector(".activator, #shopify-chat-activator, button");
    } catch (e) {
      return null;
    }
  }

  function apply(stuck) {
    var chatEl = document.querySelector("shopify-chat");
    if (!chatEl) return;
    var btn = getActivator(chatEl);
    if (!btn) return;
    if (stuck) {
      var barH = getBar().getBoundingClientRect().height;
      btn.style.setProperty("transform", "translateY(-" + Math.ceil(barH + GAP) + "px)", "important");
      btn.style.setProperty("transition", "transform 0.3s ease", "important");
    } else {
      btn.style.removeProperty("transform");
    }
  }

  function init() {
    var bar = getBar();
    if (!bar) return; // product pages only carry the bar

    var chatEl = document.querySelector("shopify-chat");
    if (!chatEl) {
      // chat widget may mount late; retry quietly
      var tries = 0;
      var timer = setInterval(function () {
        chatEl = document.querySelector("shopify-chat");
        if (chatEl || ++tries > 40) clearInterval(timer);
        if (chatEl) init();
      }, 500);
      return;
    }

    // apply current state immediately
    apply(bar.getAttribute("data-stuck") === "true");

    // then react to future state changes
    var obs = new MutationObserver(function () {
      apply(bar.getAttribute("data-stuck") === "true");
    });
    obs.observe(bar, { attributes: true, attributeFilter: ["data-stuck"] });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
